// Auto-généré par scripts/bump-version.mjs — NE PAS ÉDITER À LA MAIN
export const APP_VERSION = '1.1.0'
export const BUILD_DATE = '2026-07-16'
